import React from 'react'
import {
  Grid,
  Box,
  Button
} from "@material-ui/core"
import { ideaEditStyles } from './IdeaEditStyles'
import GroupIcon from '@material-ui/icons/Group';
import { MentionsUsers, MultiAreaCascade } from '../Shared';
import { useDispatch, useSelector } from 'react-redux';
import { ideaUpdateActions } from "./../../actions"

export const IdeaEditGeneralParticipants = () => {
  const classes = ideaEditStyles();
  const dispatch = useDispatch();

  function handleMentions(mentioned) {
    dispatch(ideaUpdateActions.setContributors(mentioned));
  };

  return (
    <Grid item xs={12}>
      <Grid container spacing={3} className={classes.root}>
        <Grid item xs={12} className={classes.header}>
          <Box display='flex' alignItems='center'>
            <Box className={classes.iconHeader}>
              <GroupIcon color="primary" />
            </Box>
            <Box className={classes.titleCard}>participantes</Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <MentionsUsers onAddMentions={handleMentions} isEdition />
        </Grid>
      </Grid>
    </Grid>
  )
}
